import { render } from "./CheckboxButtonGroup.vue?vue&type=template&id=b8aa6eac&scoped=true"
const script = {}

import "./CheckboxButtonGroup.vue?vue&type=style&index=0&id=b8aa6eac&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8aa6eac"]])

export default __exports__